<div>
  <i
    *showAuthed="true"
    [ngClass]="{ disabled: isSubmitting }"
    class="icofont icofont-pencil"
    (click)="commentEditorModal.show()"
  >
  </i>

  <!-- Discussion-comments-modal -->
  <comment-editor-modal
    #commentEditorModal
    [currentUser]="currentUser"
    [discussion]="discussion"
    [commentToEdit]="commentToEdit"
    [currentPanelMember]="currentPanelMember"
    [hideFooter]="true"
  >
  </comment-editor-modal>
  <!-- Discussion-comments-modal -->
</div>
